"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CirclePlay, Image as ImageIcon, Music, Video } from "lucide-react";
export default function MediaGalleryHero() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: actionsRef,
    isVisible: isActionsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="documenti-multimediali" className="relative w-full min-h-[70vh] flex items-center justify-center overflow-hidden bg-background py-24 md:py-32">
      {}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-primary/10" />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-3xl opacity-50 mix-blend-screen" />
        
        {}
        <div className="absolute top-1/4 left-1/4 text-primary/10 transform -rotate-12">
          <Video className="w-24 h-24" />
        </div>
        <div className="absolute bottom-1/4 right-1/4 text-primary/10 transform rotate-12">
          <Music className="w-32 h-32" />
        </div>
        <div className="absolute top-1/3 right-1/3 text-primary/10 transform rotate-45">
          <ImageIcon className="w-16 h-16" />
        </div>
      </div>

      <div className="container relative z-10 mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <div ref={headerRef} className={`transition-all duration-1000 ease-out transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="inline-flex items-center justify-center px-3 py-1 mb-6 text-sm font-medium rounded-full bg-primary/10 text-primary border border-primary/20">
            <span className="flex h-2 w-2 rounded-full bg-primary mr-2 animate-pulse"></span>
            Archivio Digitale
          </div>
          <h1 className="font-default text-5xl md:text-6xl lg:text-7xl font-bold text-foreground tracking-tight mb-4">
            Documenti Multimediali
          </h1>
          <h2 className="font-default text-2xl md:text-3xl lg:text-4xl text-primary font-medium mb-8">
            Escursioni, Suoni e Ricordi
          </h2>
        </div>

        <div ref={textRef} className={`max-w-3xl mx-auto transition-all duration-1000 delay-200 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          
        </div>

        <div ref={actionsRef} className={`flex flex-col sm:flex-row items-center gap-4 transition-all duration-1000 delay-400 ease-out transform ${isActionsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Link to="#galleria-video">
            <Button size="lg" className="rounded-full px-8 h-12 text-base">
              <CirclePlay className="mr-2 size-5" />
              Guarda i Documentari
            </Button>
          </Link>
          <Link to="#galleria-audio">
            <Button variant="outline" size="lg" className="rounded-full px-8 h-12 text-base border-primary/30 hover:bg-primary/10 hover:text-primary">
              <Music className="mr-2 size-5" />
              Ascolta i Suoni
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}